"use strict";
exports.__esModule = true;
exports.REDUCER_ACTIONS = exports.STATUS_TYPES = exports.DEFAULT_FILE_SIZE = void 0;
exports.DEFAULT_FILE_SIZE = '0b';
// Status bar messages
exports.STATUS_TYPES = {
    NOT_STARTED: 'Not started',
    IN_PROGRESS: 'Uploading',
    COMPLETE: 'Completed',
    ERROR: 'Something went wrong.',
};
// Action types for reducer
var SET_STATUS_BAR_DATA = 'SET_STATUS_BAR_DATA';
var SET_DOWNLOAD_INITIATED = 'SET_DOWNLOAD_INITIATED';
var SET_DISABLE_UPLOAD = 'SET_DISABLE_UPLOAD';
var SET_UPLOAD_STATUS = 'SET_UPLOAD_STATUS';
// Reducer Actions
exports.REDUCER_ACTIONS = {
    SET_STATUS_BAR_DATA: SET_STATUS_BAR_DATA,
    SET_DOWNLOAD_INITIATED: SET_DOWNLOAD_INITIATED,
    SET_DISABLE_UPLOAD: SET_DISABLE_UPLOAD,
    SET_UPLOAD_STATUS: SET_UPLOAD_STATUS,
};
